import { useLocation } from 'react-router-dom';
import Overview from 'src/content/overview';
import SquareSpaceAuthSignUp from 'src/content/signup/components/SquareSpaceAuthSignUp';
import {
  isLoginOrSignup,
  localSeoSignupSourceSqsp,
  localseoSignupSqspFlow,
  squareSpaceUtm
} from './config/TextMessage';
import { getCookie, localStorageMethod } from './config/FunctionHelper';
import SquareSpaceAuthConnect from 'src/content/squareSpaceConnect/SquareSpaceConnect';

// Define a component to handle the URL with query parameters
const QueryParamHandler = () => {
  // Use the `useLocation` hook to access the current location
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Access specific query parameters
  const codeParam = queryParams.get('code');
  const stateParam = queryParams.get('state');
  const error = queryParams.get('error');
  const openOrbitAIModal = queryParams.get('openOrbitAIModal');
  const orbitAiModal = queryParams.get('orbitAiModal');
  const orbitAiAddon = queryParams.get('orbitAiAddon');

  if (openOrbitAIModal === 'true' || orbitAiModal === 'true' || orbitAiAddon === 'true') {
    localStorageMethod('set', 'open_orbit_ai_modal', 'true');
  }

  // Return the component content, optionally using the extracted parameters

  // get getCookie
  let utm = getCookie(squareSpaceUtm);
  const getLocalSeoCookie = getCookie(localseoSignupSqspFlow) ?? null;
  const isLocalSeo = getLocalSeoCookie === localSeoSignupSourceSqsp;
  let isLoginOrSignupCookie = getCookie(isLoginOrSignup);
  return (
    <>
      {(codeParam && stateParam && !error) ||
      (!codeParam && stateParam && error) ? (
        (utm || isLocalSeo) && !isLoginOrSignupCookie ? (
          <SquareSpaceAuthConnect />
        ) : (
          <SquareSpaceAuthSignUp />
        )
      ) : (
        ''
      )}
      {!codeParam && !stateParam && !error && <Overview />}
    </>
  );
};

export default QueryParamHandler;
